import { defineStore } from 'pinia';
import moment from 'moment';

export type WidgetRangeKey = 'day' | 'month' | 'year';

interface RangePayload {
  searchDateType: string;
  startDate: string;
  endDate: string;
}

function getDefaultRangePayload(range: WidgetRangeKey): RangePayload {
  if (range === 'month') {
    return {
      searchDateType: '1',
      startDate: moment().startOf('month').format('YYYY-MM-DD'),
      endDate: moment().endOf('month').format('YYYY-MM-DD')
    };
  }

  if (range === 'year') {
    return {
      searchDateType: '2',
      startDate: moment().startOf('year').format('YYYY-MM-DD'),
      endDate: moment().endOf('year').format('YYYY-MM-DD')
    };
  }

  return {
    searchDateType: '0',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  };
}

export const useWidgetRangeStore = defineStore('widgetRangeStore', {
  state: () => ({
    selectCid: '' as string,
    activeRange: 'day' as WidgetRangeKey,
    searchDateType: '0',
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD')
  }),
  getters: {
    currentRangeParams: (state) => ({
      searchDateType: state.searchDateType,
      startDate: state.startDate,
      endDate: state.endDate
    })
  },
  actions: {
    setRange(range: WidgetRangeKey, payload?: Partial<RangePayload>) {
      const defaults = getDefaultRangePayload(range);
      this.activeRange = range;
      this.searchDateType = payload?.searchDateType ?? defaults.searchDateType;
      this.startDate = payload?.startDate ?? defaults.startDate;
      this.endDate = payload?.endDate ?? defaults.endDate;
    }
  }
});

